import { render, staticRenderFns } from "./elencoCoupon.vue?vue&type=template&id=25f62688&"
import script from "./elencoCoupon.vue.ts?vue&type=script&lang=ts&"
export * from "./elencoCoupon.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports